import React, { useEffect, useRef, useState } from 'react';
import { IconButton, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MaterialTable from 'material-table';
import {
   headerStyle,
   tableIcons,
   tableStyle,
} from '../../../configs/ui/TableConfig';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons/faTimesCircle';
import Axios from 'axios';
import { useSnackbar } from 'notistack';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';
import dayjs from 'dayjs';
import { TransLabel } from '../../Status/StatusLabel';
import LoadingPopup from '../../Loading/LoadingPopup';
import ErrorPopup from '../../Error/ErrorPopup';

const useStyles = makeStyles((theme) => ({
   paper: {
      // backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 4, 3),
      // backgroundColor: "#fff",
      width: '75%',
      borderRadius: '7.5px',
      maxHeight: '95vh',
      overflow: 'auto',
   },
   role: {
      color: '#5858FA',
   },
   title: {
      color: '#6E6E6E',
   },
   large: {
      width: theme.spacing(8),
      height: theme.spacing(8),
   },
   header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignContent: 'center',
      alignItems: 'center',
      margin: theme.spacing(1, 0),
   },
   content: {
      margin: theme.spacing(0, 1),
      width: '100%',
   },
   headerL: {
      margin: theme.spacing(1),
   },
}));

function ViewTable(props) {
   const classes = useStyles();
   const [isLoading, setIsLoading] = useState(false);
   const [isError, setIsError] = useState({
      error: false,
      errorStatus: '',
      errorMessage: '',
   });
   const closeRef = useRef();
   const [data, setData] = useState(props.data);
   const [resp, setResp] = useState([]);
   const [innerTableData, setInnerTableData] = useState([]);
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();

   useEffect(() => {
      getData();
   }, []);
   const getData = () => {
      setIsLoading(true);
      Axios.get(
         `/GSB/dashboard/wallet/GetHRWalletTransactionList?hrWalletId=${data.walletId}`,
      )
         .then((response) => {
            setResp(response.data);
         })
         .catch((e) => {
            LogToBackend(e);
            setIsError({
               error: true,
               errorStatus: e.response.status,
               errorMessage: e.response.data.errorAppMessageTh
                  ? e.response.data.errorAppMessageTh
                  : 'เกิดข้อผิดพลาด',
            });
         })
         .finally(() => {
            setIsLoading(false);
         });
   };
   useEffect(() => {
      setTableData();
   }, [resp]);
   const setTableData = () => {
      if (resp.length > 0) {
         const dataForMap = resp;
         const formatted = dataForMap.map((value) => {
            return Object.assign(
               {},
               {
                  ...value,
               },
            );
         });
         setIsLoading(false);
         setInnerTableData(formatted);
      }
   };
   const refreshData = () => {
      getData();
   };
   if (isLoading) return <LoadingPopup />;
   if (isError.error)
      return (
         <ErrorPopup
            onClick={props.onClickClose}
            errorStatus={isError.errorStatus}
            errorMessage={isError.errorMessage}
         />
      );
   return (
      <Paper className={classes.paper}>
         <div className={classes.header}>
            <Typography variant={'h4'}>
               ประวัติการทำรายการกระเป๋าส่วนกลาง (HR)
            </Typography>
            <IconButton
               className={classes.headerL}
               size={'small'}
               onClick={props.onClickClose}
               ref={closeRef}
            >
               <FontAwesomeIcon icon={faTimesCircle} />
            </IconButton>
         </div>
         <MaterialTable
            isLoading={isLoading}
            columns={[
               {
                  field: 'receivedDate',
                  title: 'วันที่/เวลา',
                  type: 'datetime',
                  render: (rowData) =>
                     dayjs(new Date(rowData.receivedDateEn)).format(
                        'DD/MM/BBBB  HH:mm',
                     ),
               },
               {
                  field: 'message',
                  title: 'รายละเอียด',
                  render: (rowData) => rowData.messageTh,
               },
               {
                  field: 'pointLabel',
                  title: '',
                  sorting: false,
                  export: false,
                  headerStyle: {
                     textAlign: 'center',
                  },
                  cellStyle: {
                     textAlign: 'center',
                  },
                  render: (rowData) => (
                     <TransLabel StatusType={rowData.point < 0} />
                  ),
               },
               {
                  field: 'point',
                  title: 'คะแนน',
                  type: 'numeric',
                  width: 150,
                  render: (rowData) =>
                     new Intl.NumberFormat().format(rowData.point),
               },
               {
                  field: 'pointBefore',
                  title: 'คะแนนตั้งต้น',
                  type: 'numeric',
                  width: 150,
                  render: (rowData) =>
                     new Intl.NumberFormat().format(rowData.pointBefore),
               },
               {
                  field: 'pointAfter',
                  title: 'คะแนนทั้งหมด',
                  type: 'numeric',
                  width: 150,
                  render: (rowData) =>
                     new Intl.NumberFormat().format(rowData.pointAfter),
               },
            ]}
            data={innerTableData}
            options={{
               showTitle: false,
               headerStyle: headerStyle,
               actionsColumnIndex: -1,
               addRowPosition: 'first',
               actionsCellStyle: {
                  color: '#ccc',
               },
               padding: 'dense',
               pageSize: 25,
               pageSizeOptions: [25, 50, 100],
            }}
            localization={{
               body: {
                  editRow: { deleteText: 'ต้องการลบข้อมูลนี้ใช่หรือไม่?' },
               },
               header: { actions: 'ตัวจัดการ' },
            }}
            style={tableStyle}
            icons={tableIcons}
         />
      </Paper>
   );
}

export default ViewTable;
